module.exports = __webpack_public_path__ + "static/media/Red-kurta.a9d7d9cd.webp";